import { lazy } from 'react';
import { authModules } from 'app/auth';
import ABSUtils from '@abs/utils/ABSUtils';
import themesConfig from 'app/configs/themesConfig';

const Reports = lazy(() => import('./Reports'));

const ReportsConfig = {
    settings: {
        layout: {
            config: {}
        },
        theme: {
            main: ABSUtils.IsDarkMode() ? themesConfig.exkursioDark : themesConfig.exkursio,
            navbar: ABSUtils.IsDarkMode() ? themesConfig.exkursioDark : themesConfig.exkursio,
        }
    },
    routes: [
        {
            path: '/eo/reports',
            element: <Reports />,
            auth: authModules.eo_default
        }
    ]
};

export default ReportsConfig;